var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"leading-none",style:(_vm.statusConfig.style)},[_vm._v(" "+_vm._s(_vm.statusConfig.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }